export const withDefaultRender = (columns) => {
  return columns.map((col) => {
    if (!col.render) {
      return {
        ...col,
        render: (text) => {
          // ✅ Keep numbers (including 0) and booleans (true/false)
          if (typeof text === "number" || typeof text === "boolean") {
            return text;
          }

          // ✅ Replace null, undefined, and empty string with "-"
          if (text === null || text === undefined || text === "") {
            return "-";
          }

          // ✅ Otherwise return original value
          return text;
        },
      };
    }
    return col;
  });
};
